export default __webpack_public_path__ + "static/media/top-b-6-med.9dea5af7.jpg";